import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Grid, List, ListItem, Divider, ListItemText, Typography } from '@mui/material';

const History = (props) => {
	const { history } = props;

	const [selectedIndex, setSelectedIndex] = useState(0);
	const selectedRow = selectedIndex !== null && history ? history[selectedIndex] : null;

	const _onSelectRow = (index) => {
		setSelectedIndex(index);
	};

	return (
		<Grid container spacing={3} style={{ maxHeight: '45em' }}>
			<Grid item lg={6} xs={6} style={{ maxHeight: '45em', overflowY: 'auto' }}>
				<List>
					{history.map((data, index) => (
						<>
							<ListItem
								alignItems="flex-start"
								button
								onClick={() => _onSelectRow(index)}
								selected={selectedIndex === index}
							>
								<ListItemText
									primary={(
										<>
											<Typography
												component="span"
												color="textPrimary"
												style={{ fontWeight: 'bold' }}
											>
												Stage
											</Typography>
										</>
									)}
									secondary={(
										<>
											<Typography
												component="span"
												variant="body2"
												color="textPrimary"
											>
												{moment(data.timestamp).format('DD-MM-YYYY HH:mm:ss').toString()}
											</Typography>
										</>
									)}
								/>
							</ListItem>
							<Divider component="li" />
						</>
					))}
				</List>
			</Grid>
			<Grid item lg={6} xs={6}>
				{selectedRow && (
					<>
						<Divider
							orientation="vertical"
							style={{ alignSelf: 'stretch', height: 'auto' }}
						/>
						<div>
							<Typography
								component="span"
								color="textPrimary"
								style={{ fontWeight: 'bold', marginRight: 5 }}
							>
								Field Changed:
							</Typography>
							<Typography
								component="span"
								variant="body2"
								color="textPrimary"
							>
								Stage
							</Typography>
						</div>
						<div>
							<Typography
								component="span"
								color="textPrimary"
								style={{ fontWeight: 'bold', marginRight: 5 }}
							>
								Value:
							</Typography>
							<Typography
								component="span"
								variant="body2"
								color="textPrimary"
							>
								{selectedRow.stage}
							</Typography>
						</div>
						<div>
							<Typography
								component="span"
								color="textPrimary"
								style={{ fontWeight: 'bold', marginRight: 5 }}
							>
								When:
							</Typography>
							<Typography
								component="span"
								variant="body2"
								color="textPrimary"
							>
								{moment(selectedRow.timestamp).format('DD-MM-YYYY HH:mm:ss').toString()}
							</Typography>
						</div>
						<div>
							<Typography
								component="span"
								color="textPrimary"
								style={{ fontWeight: 'bold', marginRight: 5 }}
							>
								By:
							</Typography>
							<Typography
								component="span"
								variant="body2"
								color="textPrimary"
							>
								{selectedRow.userName}
							</Typography>
						</div>
					</>
				)}
			</Grid>
		</Grid>
	);
};

History.propTypes = {
	history: PropTypes.array,
};

export default History;
